import { render, staticRenderFns } from "./RegistryView.vue?vue&type=template&id=ea76179e&scoped=true"
import script from "./RegistryView.vue?vue&type=script&lang=js"
export * from "./RegistryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea76179e",
  null
  
)

export default component.exports